module.exports = __webpack_public_path__ + "img/list.1c4858ab.svg";